export enum MultiVenueType {
    Undefined = 0,
    Registration = 1,
    Attendee = 2
}
